<template>
  <div>
    <navbar />
    <main>
      <section class="relative w-full h-full py-40 min-h-screen">
        <div
          class="absolute top-0 w-full h-full bg-gray-900 bg-no-repeat bg-full"
          
        ></div>
        <router-view />
        <footer-small absolute />
      </section>
    </main>
  </div>
</template>
<script>
/* 
  Class: User
  Description: This class summarizes all components for user stuff.
*/

/* Imports */
import Navbar from "@/components/Navbars/AuthNavbar.vue";
import FooterSmall from "@/components/Footers/FooterSmall.vue";
/* /Imports/ */

export default {
  /* 
    Define different components for reusability. 
  */
  components: {
    Navbar,
    FooterSmall,
  }
};
</script>
